module.exports = __webpack_public_path__ + "img/1ed_teacher.de668782.svg";